import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, QuestionAnswer, QuestionAnswerOption } from 'src/app/interfaces/question';

@Component({
  selector: 'question-dropdown',
  templateUrl: './dropdown-question.component.html',
  styleUrls: ['./dropdown-question.component.scss'],
})
export class DropdownQuestionComponent implements OnInit {

  constructor() { }

  @Input() question: Question | undefined;
  @Output() answered = new EventEmitter<QuestionAnswer>();

  ngOnInit() {}

  onSelected(event: Event): void {
    const value = (event.target as any).value;
    if (this.question === undefined) {
      return;
    }
    if (isNaN(value)) {
      return;
    }
    const optionId = +value;
    const selectedOption: QuestionAnswerOption | undefined = this.question.answerOptions?.find(option => option.id === optionId);
    if (selectedOption === undefined) {
      return;
    }
    this.answered.emit({
      ...selectedOption,
      options: [selectedOption.id],
      questionAnswerSet: [{
        question: this.question,
        metaRelations: []
      }]
    });
  }
}
